var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2150,-373.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Icon",
    serifId: "Dashboard Icon",
    transform: "matrix(1.09091,8.06826e-32,-1.34471e-32,1.09091,2067.09,265.873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76,101C76,99.895 76.887,99 78,99L84,99C85.105,99 86,99.887 86,101L86,107C86,108.105 85.113,109 84,109L78,109C76.895,109 76,108.113 76,107L76,101ZM88,101C88,99.895 88.887,99 90,99L96,99C97.105,99 98,99.887 98,101L98,107C98,108.105 97.113,109 96,109L90,109C88.895,109 88,108.113 88,107L88,101ZM88,113C88,111.895 88.887,111 90,111L96,111C97.105,111 98,111.887 98,113L98,119C98,120.105 97.113,121 96,121L90,121C88.895,121 88,120.113 88,119L88,113ZM76,113C76,111.895 76.887,111 78,111L84,111C85.105,111 86,111.887 86,113L86,119C86,120.105 85.113,121 84,121L78,121C76.895,121 76,120.113 76,119L76,113Z",
    style: {
      fill: "rgb(51,57,68)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.747be766df282037f4dfdbd3eb8e925e.svg";
export { ForwardRef as ReactComponent };